import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useLeasingCompaniesApi } from "../../http/leasingCompanies/api";
import { UpsertLeasingCompany } from "../../http/leasingCompanies/types";
import SvgAdd from "../icons/Add";
import LeasingCompanyForm, { LeasingCompanyFormBody } from "../leasingCompanies/LeasingCompanyForm";
import Button from "../ui/Button";
import ModalDialog from "../ui/ModalDialog";

const CreateLeasingCompanyButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const leasingCompaniesApi = useLeasingCompaniesApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (formData: LeasingCompanyFormBody) => {
    setIsSubmitting(true);
    const body: UpsertLeasingCompany = {
      name: formData.name!,
      address: formData.address,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      notes: formData.notes,
    };

    try {
      await leasingCompaniesApi.insertAdminLeasingCompany(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.leasingCompanies.new}>
          <LeasingCompanyForm onSubmit={onSubmit} isDisabled={isSubmitting} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateLeasingCompanyButton;
